/**
 * Created by jimmy on 2020/10/30.
 */
import React, { useState, useEffect } from 'react';
import * as Utils from '../../common/utils';
import './ly_recommend.less';
import * as Request from "../../common/request";

const PageModel = props => {
	let reactSwipeEl;
	const [ eventList, setEventList ] = useState([]);
	const getEventList = async () => {
		const result = await Request.get({
			url: '/zjj/recommend/hot/event'
		});
		if(!result) return;

		setEventList(result.data.list);
	};

	const [ shopList, setShopList ] = useState([]);
	const [ notes, setNotesList] = useState([]);
	const [ shopTab, setShopTab ] = useState({});
	const [ shopContentList, setShopContentList ] = useState([]);
	const [ shopFlag, setShopFlag ] = useState(false);
	const [ shopModalObj, setShopModalObj ] = useState({});
	const getShopList = async () => {
		const result = await Request.get({
			url: '/zjj/recommend/hot/shop'
		});
		if(!result) return;

		const list = result.data.list || [];
		setShopList(list);
		if(list && list[0]) {
			setShopTab(list[0]);
		}
	};
	const getNotes = async () => {
		const result = await Request.get({
			url: '/zjj/recommend/hot/notes'
		});
		if (!result) return;

		const list = result.data.list || [];
		setNotesList(list);
	};
	useEffect(() => {
		getEventList();
		getShopList();
		getNotes();
		Utils.setTitle('乐游朱家角');
	}, [123]);
	const getListByTabTitle = tabTitle => {
		let list = [];
		for(let i = 0, len = shopList.length; i < len; i++) {
			const item = shopList[i];
			if(item.tabTitle == tabTitle) {
				list = item.children;
			}
		}
		setShopContentList(list);
	};
	useEffect(() => {
		getListByTabTitle(shopTab.tabTitle);
	}, [ shopTab ]);

	const [ shopCoverIndex, setShopCoverIndex ] = useState(0);

	return (
		<section className="recommend-container">
			{
				
				notes && notes.length > 0 && <div className="block-part">
				<div className="block-space" />
				<div className="block-title">
						<span className="primary">游记攻略</span>
						<span>INTRODUCTION TO TRAVEL NOTES</span>
				</div>
				<div className="block-list">
					{
							notes && notes.length > 0 && notes.map((item, idx) => {
							return (
								<div className="block-item block-item-event" key={idx} style={{ backgroundImage: `url(${item.cover})` }} onClick={() => {
									if (item.link) {
										window.location.href = item.link;
										return;
									}
								}} />
							)
						})
					}
				</div>
			</div>
			}
		</section>
	);
};

export default PageModel;
